import Button from 'components/Button'
import { useOptInPromo } from 'hooks/useOptInPromo'

import classes from './styles.module.scss'

type OptInPromoButtonProps = {
  utmCode: string
  label: string
}

export default function OptInPromoButton(props: OptInPromoButtonProps) {
  const handleOptIn = useOptInPromo()

  const handleClick = () => {
    handleOptIn(props.utmCode)
  }

  return (
    <div className={classes.root}>
      <Button onClick={handleClick} variant='contained' size='small' className={classes.button}>
        {props.label}
      </Button>
    </div>
  )
}
